// Flight database for Nassau International Airport (NAS/LPIA)
// Auto-generated from FlightAware AeroAPI on 2026-03-05T00:19:28.725Z
import { FlightDatabase, AirlineInfo, FlightRoute, TimingGuidance } from "../types/flight";

export const AIRLINES: AirlineInfo[] = [
  {
    code: "AA",
    icaoCode: "AAL",
    name: "American Airlines",
    commonNames: ["american", "aa", "american airlines"]
  },
  {
    code: "DL",
    icaoCode: "DAL",
    name: "Delta Air Lines",
    commonNames: ["delta", "dl", "delta air lines"]
  },
  {
    code: "B6",
    icaoCode: "JBU",
    name: "JetBlue Airways",
    commonNames: ["jetblue", "b6", "jet blue"]
  },
  {
    code: "UA",
    icaoCode: "UAL",
    name: "United Airlines",
    commonNames: ["united", "ua", "united airlines"]
  },
  {
    code: "WN",
    icaoCode: "SWA",
    name: "Southwest Airlines",
    commonNames: ["southwest", "wn", "southwest airlines"]
  },
  {
    code: "NK",
    icaoCode: "NKS",
    name: "Spirit Airlines",
    commonNames: ["spirit", "nk", "spirit airlines"]
  },
  {
    code: "F9",
    icaoCode: "FFT",
    name: "Frontier Airlines",
    commonNames: ["frontier", "f9", "frontier airlines"]
  },
  {
    code: "AC",
    icaoCode: "ACA",
    name: "Air Canada",
    commonNames: ["air canada", "ac", "canada"]
  },
  {
    code: "WS",
    icaoCode: "WJA",
    name: "WestJet",
    commonNames: ["westjet", "ws", "west jet"]
  },
  {
    code: "UP",
    icaoCode: "BHS",
    name: "Bahamasair",
    commonNames: ["bahamasair", "up", "bahamas air"]
  }
];

// Common flight routes to Nassau (arrivals) - Updated from AeroAPI
export const ARRIVAL_ROUTES: FlightRoute[] = [
  {
    airline: "AA",
    flightNumber: "1624",
    flightCode: "AA1624",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "20:50",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "1884",
    flightCode: "AA1884",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:58",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "1913",
    flightCode: "AA1913",
    origin: "PHL",
    originName: "Philadelphia Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:40",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "1972",
    flightCode: "AA1972",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:11",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2246",
    flightCode: "AA2246",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:19",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2250",
    flightCode: "AA2250",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:47",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2333",
    flightCode: "AA2333",
    origin: "CLT",
    originName: "Charlotte/Douglas Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:00",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2365",
    flightCode: "AA2365",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "19:51",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2631",
    flightCode: "AA2631",
    origin: "DCA",
    originName: "Reagan National",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:19",
    terminal: "2",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2815",
    flightCode: "AA2815",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:05",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2879",
    flightCode: "AA2879",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:14",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2985",
    flightCode: "AA2985",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:44",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2993",
    flightCode: "AA2993",
    origin: "CLT",
    originName: "Charlotte/Douglas Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:48",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2994",
    flightCode: "AA2994",
    origin: "CLT",
    originName: "Charlotte/Douglas Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:57",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "3253",
    flightCode: "AA3253",
    origin: "ORD",
    originName: "Chicago O'Hare Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:00",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "3269",
    flightCode: "AA3269",
    origin: "CLT",
    originName: "Charlotte/Douglas Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:00",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AC",
    flightNumber: "938",
    flightCode: "AC938",
    origin: "YUL",
    originName: "Montreal-Trudeau",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:25",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AC",
    flightNumber: "940",
    flightCode: "AC940",
    origin: "YYZ",
    originName: "Toronto Pearson Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:55",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AC",
    flightNumber: "942",
    flightCode: "AC942",
    origin: "YYZ",
    originName: "Toronto Pearson Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "20:10",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "121",
    flightCode: "B6121",
    origin: "JFK",
    originName: "John F Kennedy Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:37",
    terminal: "5",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "241",
    flightCode: "B6241",
    origin: "MCO",
    originName: "Orlando Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:16",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "279",
    flightCode: "B6279",
    origin: "JFK",
    originName: "John F Kennedy Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:05",
    terminal: "5",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "909",
    flightCode: "B6909",
    origin: "BOS",
    originName: "Boston Logan Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:56",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "1021",
    flightCode: "B61021",
    origin: "JFK",
    originName: "John F Kennedy Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:41",
    terminal: "5",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "1393",
    flightCode: "B61393",
    origin: "FLL",
    originName: "Fort Lauderdale Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:10",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "1593",
    flightCode: "B61593",
    origin: "FLL",
    originName: "Fort Lauderdale Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:10",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "1693",
    flightCode: "B61693",
    origin: "FLL",
    originName: "Fort Lauderdale Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:27",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "BA",
    flightNumber: "252",
    flightCode: "BA252",
    origin: "GCM",
    originName: "Owen Roberts/Grand Cayman",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "20:20",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "BA",
    flightNumber: "253",
    flightCode: "BA253",
    origin: "LHR",
    originName: "London Heathrow",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:55",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "BW",
    flightNumber: "414",
    flightCode: "BW414",
    origin: "KIN",
    originName: "Norman Manley Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "CM",
    flightNumber: "196",
    flightCode: "CM196",
    origin: "PTY",
    originName: "Tocumen Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:29",
    terminal: "2",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "924",
    flightCode: "DL924",
    origin: "DTW",
    originName: "Detroit Metro Wayne Co",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:26",
    terminal: "M",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1770",
    flightCode: "DL1770",
    origin: "LGA",
    originName: "LaGuardia",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:13",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1907",
    flightCode: "DL1907",
    origin: "JFK",
    originName: "John F Kennedy Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:50",
    terminal: "4",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1938",
    flightCode: "DL1938",
    origin: "ATL",
    originName: "Hartsfield-Jackson Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:33",
    terminal: "I",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1944",
    flightCode: "DL1944",
    origin: "ATL",
    originName: "Hartsfield-Jackson Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:50",
    terminal: "I",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1947",
    flightCode: "DL1947",
    origin: "ATL",
    originName: "Hartsfield-Jackson Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:02",
    terminal: "I",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1968",
    flightCode: "DL1968",
    origin: "BOS",
    originName: "Boston Logan Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:07",
    terminal: "E",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "II",
    flightNumber: "107",
    flightCode: "II107",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "JY",
    flightNumber: "270",
    flightCode: "JY270",
    origin: "PLS",
    originName: "Providenciales Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:25",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "MQ",
    flightNumber: "3915",
    flightCode: "MQ3915",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "09:33",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "MQ",
    flightNumber: "4137",
    flightCode: "MQ4137",
    origin: "DCA",
    originName: "Reagan National",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:26",
    terminal: "2",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "PD",
    flightNumber: "775",
    flightCode: "PD775",
    origin: "YYZ",
    originName: "Toronto Pearson Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:15",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "SIY",
    flightNumber: "905",
    flightCode: "SIY905",
    origin: "PGD",
    originName: "Punta Gorda",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "TJ",
    flightNumber: "434",
    flightCode: "TJ434",
    origin: "PBI",
    originName: "Palm Beach Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "TJ",
    flightNumber: "435",
    flightCode: "TJ435",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "1454",
    flightCode: "UA1454",
    origin: "IAH",
    originName: "Houston Bush Int'ctl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:50",
    terminal: "E",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "1456",
    flightCode: "UA1456",
    origin: "EWR",
    originName: "Newark Liberty Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:53",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "1480",
    flightCode: "UA1480",
    origin: "EWR",
    originName: "Newark Liberty Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:32",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "2401",
    flightCode: "UA2401",
    origin: "ORD",
    originName: "Chicago O'Hare Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:22",
    terminal: "2",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "136",
    flightCode: "UP136",
    origin: "MHH",
    originName: "Marsh Harbour",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:55",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "138",
    flightCode: "UP138",
    origin: "MHH",
    originName: "Marsh Harbour",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:55",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "148",
    flightCode: "UP148",
    origin: "MBJ",
    originName: "Sangster Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "204",
    flightCode: "UP204",
    origin: "FLL",
    originName: "Fort Lauderdale Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:45",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "208",
    flightCode: "UP208",
    origin: "FLL",
    originName: "Fort Lauderdale Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "19:15",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "222",
    flightCode: "UP222",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "230",
    flightCode: "UP230",
    origin: "MIA",
    originName: "Miami Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "20:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "236",
    flightCode: "UP236",
    origin: "MHH",
    originName: "Marsh Harbour",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:25",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "238",
    flightCode: "UP238",
    origin: "MCO",
    originName: "Orlando Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:25",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "316",
    flightCode: "UP316",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "320",
    flightCode: "UP320",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "326",
    flightCode: "UP326",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "19:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "344",
    flightCode: "UP344",
    origin: "RSD",
    originName: "Rock Sound Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "350",
    flightCode: "UP350",
    origin: "ELH",
    originName: "North Eleuthera",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:50",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "354",
    flightCode: "UP354",
    origin: "RSD",
    originName: "Rock Sound Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "357",
    flightCode: "UP357",
    origin: "RSD",
    originName: "Rock Sound Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "09:35",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "359",
    flightCode: "UP359",
    origin: "GGT",
    originName: "Exuma Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:50",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "371",
    flightCode: "UP371",
    origin: "GGT",
    originName: "Exuma Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "375",
    flightCode: "UP375",
    origin: "GGT",
    originName: "Exuma Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "377",
    flightCode: "UP377",
    origin: "SML",
    originName: "Stella Maris",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:55",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "379",
    flightCode: "UP379",
    origin: "ZSA",
    originName: "San Salvador (Cockburn Town)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "383",
    flightCode: "UP383",
    origin: "LGI",
    originName: "Deadman's Cay",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "404",
    flightCode: "UP404",
    origin: "AXP",
    originName: "Spring Point",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "415",
    flightCode: "UP415",
    origin: "PLS",
    originName: "Providenciales Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:35",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "924",
    flightCode: "UP924",
    origin: "LGI",
    originName: "Deadman's Cay",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "934",
    flightCode: "UP934",
    origin: "LGI",
    originName: "Deadman's Cay",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "1138",
    flightCode: "UP1138",
    origin: "MHH",
    originName: "Marsh Harbour",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:10",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "3262",
    flightCode: "UP3262",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WN",
    flightNumber: "616",
    flightCode: "WN616",
    origin: "MCO",
    originName: "Orlando Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WS",
    flightNumber: "2046",
    flightCode: "WS2046",
    origin: "YYC",
    originName: "Calgary Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:17",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WS",
    flightNumber: "2328",
    flightCode: "WS2328",
    origin: "YYZ",
    originName: "Toronto Pearson Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:20",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WS",
    flightNumber: "2580",
    flightCode: "WS2580",
    origin: "YYZ",
    originName: "Toronto Pearson Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:40",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "103",
    flightCode: "WU103",
    origin: "FLL",
    originName: "Fort Lauderdale Intl",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:50",
    terminal: "4",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "201",
    flightCode: "WU201",
    origin: "ELH",
    originName: "North Eleuthera",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:50",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "203",
    flightCode: "WU203",
    origin: "ELH",
    originName: "North Eleuthera",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:50",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "403",
    flightCode: "WU403",
    origin: "TBI",
    originName: "New Bight",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:20",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "501",
    flightCode: "WU501",
    origin: "SAQ",
    originName: "San Andros",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:50",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "517",
    flightCode: "WU517",
    origin: "TZN",
    originName: "Congo Town",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "519",
    flightCode: "WU519",
    origin: "TZN",
    originName: "Congo Town",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "603",
    flightCode: "WU603",
    origin: "MHH",
    originName: "Marsh Harbour",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "09:20",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "607",
    flightCode: "WU607",
    origin: "MHH",
    originName: "Marsh Harbour",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:20",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "702",
    flightCode: "WU702",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "703",
    flightCode: "WU703",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "708",
    flightCode: "WU708",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "709",
    flightCode: "WU709",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "718",
    flightCode: "WU718",
    origin: "FPO",
    originName: "Grand Bahama Int'l (Freeport Int'l)",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "801",
    flightCode: "WU801",
    origin: "GGT",
    originName: "Exuma Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:50",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "805",
    flightCode: "WU805",
    origin: "GGT",
    originName: "Exuma Int'l",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "19:20",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "901",
    flightCode: "WU901",
    origin: "BIM",
    originName: "South Bimini",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:50",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "903",
    flightCode: "WU903",
    origin: "BIM",
    originName: "South Bimini",
    destination: "NAS",
    destinationName: "Lynden Pindling Int'l (Nassau)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:50",
    terminal: "A",
    frequency: "daily",
    isActive: true
  }
];

// Common departure routes from Nassau - Updated from AeroAPI
export const DEPARTURE_ROUTES: FlightRoute[] = [
  {
    airline: "AA",
    flightNumber: "859",
    flightCode: "AA859",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "CLT",
    destinationName: "Charlotte/Douglas Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:27",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "1681",
    flightCode: "AA1681",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MIA",
    destinationName: "Miami Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:06",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2100",
    flightCode: "AA2100",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MIA",
    destinationName: "Miami Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:45",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "2178",
    flightCode: "AA2178",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "CLT",
    destinationName: "Charlotte/Douglas Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:00",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AA",
    flightNumber: "9794",
    flightCode: "AA9794",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MIA",
    destinationName: "Miami Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "20:30",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AC",
    flightNumber: "939",
    flightCode: "AC939",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "YUL",
    destinationName: "Montreal-Trudeau",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:15",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AC",
    flightNumber: "941",
    flightCode: "AC941",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "YYZ",
    destinationName: "Toronto Pearson Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:50",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "AC",
    flightNumber: "943",
    flightCode: "AC943",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "YYZ",
    destinationName: "Toronto Pearson Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "21:10",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "240",
    flightCode: "B6240",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MCO",
    destinationName: "Orlando Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:22",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "280",
    flightCode: "B6280",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "JFK",
    destinationName: "John F Kennedy Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:10",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "294",
    flightCode: "B6294",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FLL",
    destinationName: "Fort Lauderdale Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:32",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "522",
    flightCode: "B6522",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "JFK",
    destinationName: "John F Kennedy Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:42",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "910",
    flightCode: "B6910",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "BOS",
    destinationName: "Boston Logan Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:00",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "1022",
    flightCode: "B61022",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "JFK",
    destinationName: "John F Kennedy Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:00",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "1394",
    flightCode: "B61394",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FLL",
    destinationName: "Fort Lauderdale Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:15",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "2194",
    flightCode: "B62194",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FLL",
    destinationName: "Fort Lauderdale Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:15",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "B6",
    flightNumber: "2694",
    flightCode: "B62694",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FLL",
    destinationName: "Fort Lauderdale Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:00",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "BW",
    flightNumber: "415",
    flightCode: "BW415",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "KIN",
    destinationName: "Norman Manley Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:55",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "CM",
    flightNumber: "197",
    flightCode: "CM197",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "PTY",
    destinationName: "Tocumen Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "948",
    flightCode: "DL948",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "DTW",
    destinationName: "Detroit Metro Wayne Co",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:41",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1769",
    flightCode: "DL1769",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "LGA",
    destinationName: "LaGuardia",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:23",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1839",
    flightCode: "DL1839",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "JFK",
    destinationName: "John F Kennedy Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:03",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1867",
    flightCode: "DL1867",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ATL",
    destinationName: "Hartsfield-Jackson Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:16",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1918",
    flightCode: "DL1918",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "JFK",
    destinationName: "John F Kennedy Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:15",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1936",
    flightCode: "DL1936",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "BOS",
    destinationName: "Boston Logan Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:40",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1956",
    flightCode: "DL1956",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ATL",
    destinationName: "Hartsfield-Jackson Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:27",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1965",
    flightCode: "DL1965",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ATL",
    destinationName: "Hartsfield-Jackson Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:15",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "DL",
    flightNumber: "1976",
    flightCode: "DL1976",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ATL",
    destinationName: "Hartsfield-Jackson Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:59",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "II",
    flightNumber: "102",
    flightCode: "II102",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MIA",
    destinationName: "Miami Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "JY",
    flightNumber: "271",
    flightCode: "JY271",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "PLS",
    destinationName: "Providenciales Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "PD",
    flightNumber: "776",
    flightCode: "PD776",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "YYZ",
    destinationName: "Toronto Pearson Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:15",
    terminal: "3",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "681",
    flightCode: "UA681",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "EWR",
    destinationName: "Newark Liberty Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:25",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "1455",
    flightCode: "UA1455",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "IAH",
    destinationName: "Houston Bush Int'ctl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:53",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "1539",
    flightCode: "UA1539",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "EWR",
    destinationName: "Newark Liberty Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:55",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UA",
    flightNumber: "2422",
    flightCode: "UA2422",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ORD",
    destinationName: "Chicago O'Hare Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:35",
    terminal: "C",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "135",
    flightCode: "UP135",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MHH",
    destinationName: "Marsh Harbour",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:15",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "137",
    flightCode: "UP137",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MHH",
    destinationName: "Marsh Harbour",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:15",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "147",
    flightCode: "UP147",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MBJ",
    destinationName: "Sangster Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "203",
    flightCode: "UP203",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FLL",
    destinationName: "Fort Lauderdale Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "207",
    flightCode: "UP207",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FLL",
    destinationName: "Fort Lauderdale Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "221",
    flightCode: "UP221",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MIA",
    destinationName: "Miami Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "229",
    flightCode: "UP229",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MIA",
    destinationName: "Miami Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "235",
    flightCode: "UP235",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MHH",
    destinationName: "Marsh Harbour",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "237",
    flightCode: "UP237",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MCO",
    destinationName: "Orlando Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "315",
    flightCode: "UP315",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "06:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "319",
    flightCode: "UP319",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "09:15",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "325",
    flightCode: "UP325",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "343",
    flightCode: "UP343",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "RSD",
    destinationName: "Rock Sound Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "09:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "349",
    flightCode: "UP349",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ELH",
    destinationName: "North Eleuthera",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:25",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "353",
    flightCode: "UP353",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "RSD",
    destinationName: "Rock Sound Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:15",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "370",
    flightCode: "UP370",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "GGT",
    destinationName: "Exuma Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "06:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "374",
    flightCode: "UP374",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "GGT",
    destinationName: "Exuma Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "378",
    flightCode: "UP378",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ZSA",
    destinationName: "San Salvador (Cockburn Town)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "00:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "401",
    flightCode: "UP401",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:30",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "403",
    flightCode: "UP403",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "AXP",
    destinationName: "Spring Point",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "427",
    flightCode: "UP427",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MYG",
    destinationName: "Mayaguana",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "09:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "923",
    flightCode: "UP923",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "LGI",
    destinationName: "Deadman's Cay",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "UP",
    flightNumber: "933",
    flightCode: "UP933",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "LGI",
    destinationName: "Deadman's Cay",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "10:05",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WN",
    flightNumber: "617",
    flightCode: "WN617",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MCO",
    destinationName: "Orlando Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:55",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WS",
    flightNumber: "2047",
    flightCode: "WS2047",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "YYC",
    destinationName: "Calgary Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:40",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WS",
    flightNumber: "2521",
    flightCode: "WS2521",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "YYZ",
    destinationName: "Toronto Pearson Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:15",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WS",
    flightNumber: "2587",
    flightCode: "WS2587",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "YYZ",
    destinationName: "Toronto Pearson Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:15",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "102",
    flightCode: "WU102",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FLL",
    destinationName: "Fort Lauderdale Intl",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "11:00",
    terminal: "B",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "200",
    flightCode: "WU200",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ELH",
    destinationName: "North Eleuthera",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "202",
    flightCode: "WU202",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "ELH",
    destinationName: "North Eleuthera",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "16:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "402",
    flightCode: "WU402",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "TBI",
    destinationName: "New Bight",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "13:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "500",
    flightCode: "WU500",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "SAQ",
    destinationName: "San Andros",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:00",
    terminal: "1",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "516",
    flightCode: "WU516",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "TZN",
    destinationName: "Congo Town",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "06:45",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "518",
    flightCode: "WU518",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "TZN",
    destinationName: "Congo Town",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "602",
    flightCode: "WU602",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MHH",
    destinationName: "Marsh Harbour",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "606",
    flightCode: "WU606",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "MHH",
    destinationName: "Marsh Harbour",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "701",
    flightCode: "WU701",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "704",
    flightCode: "WU704",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "08:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "707",
    flightCode: "WU707",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "12:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "712",
    flightCode: "WU712",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "15:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "716",
    flightCode: "WU716",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "FPO",
    destinationName: "Grand Bahama Int'l (Freeport Int'l)",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "17:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "800",
    flightCode: "WU800",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "GGT",
    destinationName: "Exuma Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "07:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "804",
    flightCode: "WU804",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "GGT",
    destinationName: "Exuma Int'l",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "18:00",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "900",
    flightCode: "WU900",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "BIM",
    destinationName: "South Bimini",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "09:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  },
  {
    airline: "WU",
    flightNumber: "902",
    flightCode: "WU902",
    origin: "NAS",
    originName: "Lynden Pindling Int'l (Nassau)",
    destination: "BIM",
    destinationName: "South Bimini",
    scheduledDays: [1, 2, 3, 4, 5, 6, 0], // Daily
    scheduledTime: "14:30",
    terminal: "A",
    frequency: "daily",
    isActive: true
  }
];

export const FLIGHT_DATABASE: FlightDatabase = {
  arrivals: ARRIVAL_ROUTES,
  departures: DEPARTURE_ROUTES,
  airlines: AIRLINES
};

// Timing guidance for arrivals and departures
export const TIMING_GUIDANCE: Record<"arrival" | "departure", TimingGuidance> = {
  arrival: {
    type: "arrival",
    recommendedOffset: 20, // 20 minutes after scheduled arrival
    description: "Allow time for customs, immigration, and baggage claim",
    factors: [
      "Customs and immigration processing",
      "Baggage claim wait time",
      "Walk to ground transportation area",
      "Peak hours may require additional time"
    ]
  },
  departure: {
    type: "departure",
    recommendedOffset: -150, // 2.5 hours before scheduled departure
    description: "Arrive at airport 2.5 hours before international flights",
    factors: [
      "Check-in and baggage drop",
      "Security screening",
      "Immigration and customs",
      "Walk to departure gate",
      "Recommended buffer for delays"
    ]
  }
};

// Airport codes and names for validation - Updated from AeroAPI
export const AIRPORT_CODES = {
  NAS: "Nassau International Airport (LPIA)",
  FLL: "FLL Airport",
  FPO: "FPO Airport",
  GGT: "GGT Airport",
  MHH: "MHH Airport",
  YYC: "YYC Airport",
  PLS: "PLS Airport",
  MIA: "MIA Airport",
  ATL: "ATL Airport",
  RSD: "RSD Airport",
  ELH: "ELH Airport",
  MCO: "MCO Airport",
  AXP: "AXP Airport",
  YYZ: "YYZ Airport",
  JFK: "JFK Airport",
  CLT: "CLT Airport",
  ORD: "ORD Airport",
  LGA: "LGA Airport",
  TBI: "TBI Airport",
  LHR: "LHR Airport",
  PBI: "PBI Airport",
  EWR: "EWR Airport",
  BOS: "BOS Airport",
  DCA: "DCA Airport",
  KIN: "KIN Airport",
  DTW: "DTW Airport",
  YUL: "YUL Airport",
  PHL: "PHL Airport",
  SML: "SML Airport",
  PTY: "PTY Airport",
  BIM: "BIM Airport",
  SAQ: "SAQ Airport",
  TZN: "TZN Airport",
  GCM: "GCM Airport",
  LGI: "LGI Airport",
  KBKV: "KBKV Airport",
  TYM: "TYM Airport",
  MBJ: "MBJ Airport",
  ZSA: "ZSA Airport",
  PGD: "PGD Airport",
  IAH: "IAH Airport",
  MYG: "MYG Airport"
};
